/**
 * Testimonials section component - using original Portugal Portuguese text
 */

import { Card } from '../ui/Card';
import { useIntersectionObserver } from '@/hooks/useIntersectionObserver';
import { motion } from 'framer-motion';
import testimonialsData from "@/data/testimonials.json";
const testimonials = testimonialsData.items;
const sectionTitle = testimonialsData.section_title;
const sectionTitleParts = testimonialsData.section_title_parts || [{ text: sectionTitle, highlight: false }];
const sectionSubtitle = testimonialsData.section_subtitle;

export function Testimonials() {
  const { ref, isIntersecting } = useIntersectionObserver({ threshold: 0.1 });

  return (
    <section id="testimonials" ref={ref} className="section">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isIntersecting ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.6 }}
          className="has-text-centered mb-6"
        >
          <h2 className="title is-2 has-text-weight-bold">
            {sectionTitleParts.map((part, index) => (
              part.highlight ? (
                <span key={index} className="gradient-text">{part.text}</span>
              ) : (
                <span key={index}>{part.text}</span>
              )
            ))}
          </h2>
          <p className="subtitle is-5" style={{ maxWidth: '600px', margin: '0 auto' }}>
            {sectionSubtitle}
          </p>
        </motion.div>

        <div className="grid-3">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.id}
              initial={{ opacity: 0, y: 30 }}
              animate={isIntersecting ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              <Card className="testimonial-card" style={{ padding: '2rem' }}>
                {/* Rating Stars */}
                <div className="testimonial-stars">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <svg key={i} style={{ width: '20px', height: '20px', color: '#fbbf24', marginRight: '0.25rem' }} fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                </div>

                {/* Testimonial Text */}
                <p className="testimonial-text">
                  "{testimonial.text}"
                </p>

                {/* Author Info */}
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div className="testimonial-avatar" style={{
                    width: '3rem',
                    height: '3rem',
                    background: 'linear-gradient(135deg, var(--color-lime-400), var(--color-lime-600))',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '1rem',
                    color: '#ffffff',
                    fontWeight: 600,
                    fontSize: '0.875rem'
                  }}>
                    {testimonial.initials}
                  </div>
                  <div>
                    <div className="testimonial-name">{testimonial.name}</div>
                    <div className="testimonial-location">{testimonial.location}</div>
                  </div>
                </div>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
